
import styles from './ScatteredImageAndText.module.css';
import { useSmoother } from './common/SmootherContext.js';
import { useEffect } from 'react';

function ScatteredImageAndText({
    media1,
    text1,
    media2,
    media3,
    text2
}) {

    const smoother = useSmoother();

    useEffect(() => {
        // Only apply effect if not on mobile
        const isMobile = window.matchMedia('(max-width: 915px)').matches;

        if (!isMobile) {
            const timeout = setTimeout(() => {
                if (smoother) {
                    smoother.effects("[data-speed]"); // reapply scroll effects
                    smoother.refresh(); // re-calculate layout
                }
            }, 300); // slight delay helps ensure DOM is fully updated

            return () => clearTimeout(timeout);
        }
    }, [smoother]);

    const getMediaType = (url) => {
        if (!url) return null;
        const extension = url.split('.').pop().toLowerCase();
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

        if (videoExtensions.includes(extension)) return 'video';
        if (imageExtensions.includes(extension)) return 'image';
        return null;
    };

    const mediaType1 = getMediaType(media1.fields.file.url);
    const mediaType2 = getMediaType(media2.fields.file.url);
    const mediaType3 = getMediaType(media3.fields.file.url);

    let media1Pad;
    let media2Pad;
    let media3Pad;

    if (mediaType1 === 'image') {
        media1Pad = (media1.fields.file.details.image.height / media1.fields.file.details.image.width) * 100;
    } else if (mediaType1 === 'video') {
        media1Pad = 56.25; // Default to 16:9 aspect ratio if video dimensions are unavailable
    }

    if (mediaType2 === 'image') {
        media2Pad = (media2.fields.file.details.image.height / media2.fields.file.details.image.width) * 100;
    } else if (mediaType2 === 'video') {
        media2Pad = 56.25; // Default to 16:9 aspect ratio if video dimensions are unavailable
    }

    if (mediaType3 === 'image') {
        media3Pad = (media3.fields.file.details.image.height / media3.fields.file.details.image.width) * 100;
    } else if (mediaType3 === 'video') {
        media3Pad = 56.25; // Default to 16:9 aspect ratio if video dimensions are unavailable
    }



    return (
        <div className={styles.scattered_image_text}>
            <div className={styles.row}>
                <div className={styles.cell} data-speed=".9">
                    <div
                        className={styles.mediawrap}
                        style={{ paddingTop: `${media1Pad}%` }}
                    >
                        {media1 && mediaType1 === "video" && (
                            <video className={styles.video} autoPlay loop muted>
                                <source src={media1.fields.file.url} type="video/mp4" />
                            </video>
                        )}

                        {media1 && mediaType1 === "image" && (
                            <img
                                className={styles.image}
                                src={media1.fields.file.url}
                                alt={media1.fields.alt}
                                width={media1.fields.file.details.image.width}
                                height={media1.fields.file.details.image.height}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.cell}>
                    <p>{text1}</p>
                </div>

            </div>
            <div className={styles.row}>

                <div className={styles.cell} data-speed=".8">
                    <div className={styles.mediawrap} style={{ paddingTop: `${media2Pad}%` }}>
                        {media2 && mediaType2 === "video" && (
                            <video className={styles.video} autoPlay loop muted>
                                <source src={media2.fields.file.url} type="video/mp4" />
                            </video>
                        )}

                        {media2 && mediaType2 === "image" && (
                            <img
                                className={styles.image}
                                src={media2.fields.file.url}
                                alt={media2.fields.title}
                                width={media2.fields.file.details.image.width}
                                height={media2.fields.file.details.image.height}
                            />
                        )}
                    </div>

                </div>

                <div className={styles.cell} data-speed="1">
                    <div className={styles.mediawrap} style={{ paddingTop: `${media3Pad}%` }}>
                        {media3 && mediaType3 === "video" && (
                            <video className={styles.video} autoPlay loop muted playsInline>
                                <source src={media3.fields.file.url} type="video/mp4" />
                            </video>
                        )}
                        {media3 && mediaType3 === "image" && (
                            <img
                                className={styles.image}
                                src={media3.fields.file.url}
                                alt={media3.fields.title}
                                width={media3.fields.file.details.image.width}
                                height={media3.fields.file.details.image.height}
                            />
                        )}
                    </div>
                </div>

            </div>
            <div className={styles.row}>
                <div className={styles.cell} data-speed=".9">
                    <p>{text2}</p>
                </div>
            </div>
        </div>
    );
}

export default ScatteredImageAndText;
